import React, { useState } from 'react';
import { ContextMenuTrigger } from 'react-contextmenu';
import { isEmpty, noop } from 'lodash';
import Icon from '@omilia/icon';

import { theme } from 'theme';
import { RenderItemParams } from 'components/GenericTree';
import { useTreeActions } from '../TreeActionsContext';
import { ColorContainer, ListItemContainer, SIconContainer } from './styled';
import TextInput from './TextInput';
import ContextMenu from './ContextMenu';

const TreeItem = ({
  item,
  onExpand,
  query,
  onCollapse,
  onDoubleClickItem,
  onUpload,
  depth,
  width,
  path,
}: RenderItemParams & { width?: number }) => {
  const [name, setName] = useState(item.data.title);
  const { setEdit } = useTreeActions();
  const goToEditMode = () => setEdit(item.id, true);
  const exitEditMode = () => setEdit(item.id, false);
  const onBlur = () => {
    setName(item.data.title);
    exitEditMode();
  };
  const toggleAction = item.isExpanded ? onCollapse : onExpand;
  const toggle = () => toggleAction(item.id);
  const open = () => (item.isFolder ? noop() : onDoubleClickItem(item));

  return (
    <ColorContainer>
      <ContextMenuTrigger id={item.id}>
        <ListItemContainer
          data-test={`${item.isFolder ? 'folder-element' : 'file-element'}-${
            item.data.title
          }`}
          depth={depth}
          onClick={toggle}
          onDoubleClick={open}
        >
          <SIconContainer>
            {item.isFolder && (
              <Icon
                data-test={item.isExpanded ? 'caret-down' : 'caret-right'}
                glyph={item.isExpanded ? 'caret-down' : 'caret-right'}
                primaryColor={theme.colors.moodyBlue2}
                size="14"
              />
            )}
            <Icon
              glyph={item.isFolder ? 'folder' : 'file'}
              primaryColor={theme.colors.moodyBlue2}
              size="14"
            />
          </SIconContainer>

          <TextInput
            exitEditMode={exitEditMode}
            item={item}
            match={query}
            name={name}
            setName={setName}
            width={width}
            onBlur={onBlur}
          />
        </ListItemContainer>
      </ContextMenuTrigger>

      {isEmpty(query) && (
        <ContextMenu
          edit={goToEditMode}
          item={item}
          open={open}
          path={path}
          toggle={toggle}
          upload={onUpload}
        />
      )}
    </ColorContainer>
  );
};

export default TreeItem;
